import {Component, computed, effect, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PerfilServicesService} from '../services/perfil.service';
import {LayoutService} from 'src/app/layout/service/app.layout.service';
import * as CryptoJS from 'crypto-js'
import {TramitePagosService} from "../../pagos/services/tramite-pagos.service";
import {LoginServices} from "../../../auth/login/services/login.service";
import {FileUtilsService} from "../../../shared/services/file-utils-service";
import { UsuariosInterface } from '../../mnto-usuarios/interfaces/usuarios.interface';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Persona, Tipos } from 'src/app/auth/register/interfaces/tipos';
import { RegistroService } from 'src/app/auth/register/services/registro-service';
import { error } from 'logrocket';
import { Param } from 'src/app/shared/interfaces/param-interface';
import { UsuariosService } from '../../mnto-usuarios/Services/usuarios.service';
import { PersonasService } from 'src/app/shared/services/personas-service';
import { PersonaInfo } from 'src/app/shared/interfaces/shared-interface';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-perfil-page',
    templateUrl: './perfil-page.component.html',
    styleUrls: ['./perfil-page.component.css']
})
export class PerfilPageComponent implements OnInit {
    @Input() perfilCorreo = 'perfilpage';
    @Output() onUsuarioDialogChange = new EventEmitter<{openDialog:boolean|any; estadoAccion:boolean|any; submitted:boolean|any}>();
    usuarioSeleccionado: UsuariosInterface | PersonaInfo | null = null;
    numeroDocumento: string = ""
    imagenDemo: string = ''
    showEditarFoto: boolean = false
    loading: boolean=false;
    mostrarUsuarioDialog = false;
    usuarioDialog = false;
    idPersonaUsuarioActual: number | null | undefined;
    idTipoPersona!: number | undefined;
    constructor(private perfil: PerfilServicesService, public loginServices: LoginServices,
                private perfilUser: PerfilServicesService, private layoutService: LayoutService,
                public tramitePagosService: TramitePagosService,protected fileUtilsService: FileUtilsService,
                private registroService: RegistroService, private usuariosService: UsuariosService,public personaService: PersonasService) {
    }
    ngOnInit(): void {
        this.tramitePagosService.consultarSaldo()

        this.obtenerUsuarioDesdeCorreo();
    }
    fotoPerfil: any = null

    obtenerUsuarioDesdeCorreo() {
        const correo = this.loginServices.session()?.perfil?.correo;
        if (!correo) return;

        const params: Param[] = [{ key: 'correo', value: correo }];
        this.personaService.consultaInfo(params).subscribe({
            next: (resp) => {
            if (resp.body && resp.body.length > 0) {
                const usuario = resp.body[0];
                this.usuarioSeleccionado = resp.body[0];
                this.idPersonaUsuarioActual = resp.body[0].idTipoPersona;
                this.idTipoPersona = usuario.idTipoPersona!;
            }
            }
        });
    }
    guardarImagen(e: any) {
        this.fotoPerfil = e.currentFiles ? e.currentFiles[0] : e.currentFiles[0]
    }
    convertirImagen(e: any) {
        var pattern = /image-*/;
        var reader = new FileReader();
        if (!this.fotoPerfil.type.match(pattern)) {
            alert('invalid format');
            return;
        }
        reader.onload = this._handleReaderLoaded.bind(this.fotoPerfil);
        reader.readAsDataURL(this.fotoPerfil);
    }
    _handleReaderLoaded(e: any) {
        let reader = e.target;
        this.perfilUser.imageDemo.set(reader.result)
        const byteCharacters = atob(reader.result.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const hash = CryptoJS.SHA256(byteArray.toString());
    }
    actualizarFoto(e: any) {
        var file = e.files ? e.files[0] : e.files[0]
        var pattern = /image-*/;
        var reader = new FileReader();
        if (!file.type.match(pattern)) {
            alert('invalid format');
            return;
        }
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsDataURL(file);
        let hash = this.calcularHash(reader.result as string);
    }
    calcularHash(dataURL: string) {
        const byteCharacters = atob(dataURL.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
    }
    imagenPerfilEffect = effect(() => {
        this.imagenDemo = this.perfilUser.imageDemo()
    })

    abrirUsuarioDialog() {
        this.mostrarUsuarioDialog = true;
    }

    cerrarUsuarioDialog() {
        this.mostrarUsuarioDialog = false;
    }

    editarUsuario(usuario: UsuariosInterface | PersonaInfo) {
        this.usuarioSeleccionado = usuario;
        this.mostrarUsuarioDialog = true;
    }

    guardarCambiosPerfil(datos: { nombres: string; apellidos: string }) {
        const nombresVacios = !datos.nombres || datos.nombres.trim() === '';
        const apellidosVacios = !datos.apellidos || datos.apellidos.trim() === '';

        if(this.idPersonaUsuarioActual === 2 && nombresVacios){
            Swal.fire({
                title: "Campos vacíos",
                text: "Debe completar Los Campos Requeridos",
                icon: "warning"
            });
            this.cerrarUsuarioDialog();
            return;
        }
        if (this.idPersonaUsuarioActual === 1 && (nombresVacios || apellidosVacios)) {
            Swal.fire({
                title: "Campos vacíos",
                text: "Debe completar Los Campos Requeridos",
                icon: "warning"
            });
            this.cerrarUsuarioDialog();
            return;
        }
        const payload: Persona = {
            nombres: datos.nombres,
            apellidos: datos.apellidos,
            idTipoPersona: Number(this.idPersonaUsuarioActual),
            uniqueIdPersona: this.loginServices.session()?.perfil?.uniqueId,
            session: {
                uniqueId: this.loginServices.session()?.perfil?.uniqueId,
                usuario: this.loginServices.session()?.perfil?.usuario,
                documento: this.loginServices.session()?.perfil?.documento,
                correo: this.loginServices.session()?.perfil?.correo,

            }
        };
        this.registroService.editarPerfil(payload).subscribe({
            next: (res) => {
            if (res.status === 200 || res.status === 201) {
                this.loginServices.session.update(current => {
                    if (!current) return null;
                    const nuevosNombres = datos.nombres;
                    let nuevosApellidos = datos.apellidos;
                    if(nuevosApellidos == null){
                        nuevosApellidos = ''
                    }
                    return {
                        ...current,
                        perfil: {
                            ...current.perfil,
                            nombres: datos.nombres,
                            apellidos: datos.apellidos,
                            nombreCompleto: `${nuevosNombres} ${nuevosApellidos}`
                        }
                    };
                });
                Swal.fire({
                    title: "Éxito",
                    text: "Su perfil se actualizó exitosamente.",
                    icon: "success"
                });
                this.mostrarUsuarioDialog = false;
            }
            },
            error: (err) => {
                Swal.fire({
                    title: "Error",
                    text: "No se pudo actualizar su perfil, intente de nuevo.",
                    icon: "error"
                });
                console.error('Error al editar perfil:', err);
                this.mostrarUsuarioDialog = false;
            },
            complete() {

            },
        });
    }
}
